// components/ProfileCard.jsx
import { ExternalLink } from 'lucide-react';

export default function ContentCreationBox(props) {
  return (
    
    <div className=""> 
       
       <div className="top-0 left-0 mx-1 h-1 bg-gradient-to-r rounded-t-full from-[#6db33f] to-[#80ea6e]"></div>

       <div className="max-w-sm mx-auto bg-[#252A30] rounded-xl p-6 text-white border border-[#30363d] shadow-lg">
      <div className="flex items-center justify-between mb-2">
        {props.social === "Medium" ? 
        <><div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-medium mb-4">
           
           {props.social}
         </div>
         <div className="icon-box">
         <svg xmlns="http://www.w3.org/2000/svg" class="ionicon spring" viewBox="0 0 512 512"><path d="M416 221.25V416a48 48 0 01-48 48H144a48 48 0 01-48-48V96a48 48 0 0148-48h98.75a32 32 0 0122.62 9.37l141.26 141.26a32 32 0 019.37 22.62z" fill="none" stroke="currentColor" stroke-linejoin="round" stroke-width="32"/><path d="M256 56v120a32 32 0 0032 32h120M176 288h160M176 368h160" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>
         </div> </>  : <> <div className="inline-flex items-center px-3 py-1 rounded-full bg-red-500/10 text-red-400 text-red-400 text-sm font-medium mb-4">
                    {props.social}
                  </div>
         <div className="icon-box">
         <svg xmlns="http://www.w3.org/2000/svg" class="ionicon spring" viewBox="0 0 512 512"><path d="M374.79 308.78L457.5 367a16 16 0 0022.5-14.62V159.62A16 16 0 00457.5 145l-82.71 58.22A16 16 0 00368 216.3v79.4a16 16 0 006.79 13.08z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><path d="M268 384H84a52.15 52.15 0 01-52-52V180a52.15 52.15 0 0152-52h184.48A51.68 51.68 0 01320 179.52V332a52.15 52.15 0 01-52 52z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>
         </div> </>}
       
         
      </div>
      <h2 className="text-xl font-bold">{props.name}</h2>
      <a href={props.source} target="_blank" rel="noreferrer" className="username-text text-sm">{props.username}</a>
      <p className="mt-3 text-sm text-gray-300">
        {props.bio}
      </p>
      <a
        href={props.source} target='_blank' rel="noreferrer"
        className="inline-flex items-center username-text text-sm mt-4 hover:underline"
      >
        {props.linktext} <ExternalLink className="w-4 h-4 ml-1" />
      </a>
    </div>
   </div>
  );
}
